import React, { createContext, useContext, useState, useCallback } from 'react';
import { playSound } from '../../lib/effects';

let toastSeq = 0;

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
	const [toasts, setToasts] = useState([]);

	const pushToast = useCallback((message, error = false) => {
		toastSeq += 1;
		const id = `toast-${toastSeq}`;
		playSound(error ? 'error' : 'success');
		setToasts(prev => [...prev, { id, message, error }]);
		setTimeout(() => {
			setToasts(prev => prev.filter(t => t.id !== id));
		}, 2600);
	}, []);

	return (
		<ToastContext.Provider value={{ pushToast }}>
			{children}
			<div style={{
				pointerEvents: 'none', position: 'fixed', right: '24px', bottom: '24px',
				zIndex: 140, display: 'flex', flexDirection: 'column', gap: '10px'
			}}>
				{toasts.map((toast) => (
					<div
						key={toast.id}
						role="status"
						className="pf-toast"
						style={{
							display: 'flex', alignItems: 'center', gap: '12px',
							borderRadius: '14px', background: 'var(--card)',
							padding: '12px 18px 12px 13px',
							fontFamily: 'var(--font-sans)', fontSize: '15.5px', fontWeight: 600,
							color: 'var(--ink)',
							boxShadow: '4px 5px 0 rgba(38,37,31,.28)',
							border: '2px solid var(--bd)',
							pointerEvents: 'auto'
						}}
					>
						<span style={{
							display: 'inline-flex', height: '30px', width: '30px', flexShrink: 0,
							alignItems: 'center', justifyContent: 'center',
							borderRadius: '52% 48% 50% 50%', border: '2px solid var(--bd)',
							background: toast.error ? '#e5484d' : 'var(--accent)',
							transform: 'rotate(-4deg)'
						}}>
							{toast.error ? (
								<svg width={16} height={16} viewBox="0 0 16 16" fill="none">
									<path d="M4 4l8 8M12 4l-8 8" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
								</svg>
							) : (
								<svg width={16} height={16} viewBox="0 0 16 16" fill="none">
									<path d="M3 8l3.5 3.5L13 5" stroke="#111" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							)}
						</span>
						{toast.message}
					</div>
				))}
			</div>
		</ToastContext.Provider>
	);
};
